import { render, staticRenderFns } from "./aloneTab.vue?vue&type=template&id=1a5b76d8&scoped=true&"
import script from "./aloneTab.vue?vue&type=script&lang=js&"
export * from "./aloneTab.vue?vue&type=script&lang=js&"
import style0 from "./aloneTab.vue?vue&type=style&index=0&id=1a5b76d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5b76d8",
  null
  
)

export default component.exports